// extracted by mini-css-extract-plugin
module.exports = {"noAppointmentsBlockArea":"noAppointmentsBlock-module--noAppointmentsBlockArea--n7vXD","noAppointmentsBlock":"noAppointmentsBlock-module--noAppointmentsBlock--1tc3L"};